import { getTPPServices } from './tppDi';
import { validKey } from '../utils';
const URL_CACHE = 'URL_CACHE';
const URL_PARSER_CACHE = 'URL_PARSER_CACHE';
const URL_REPLACER_CACHE = 'URL_REPLACER_CACHE';

const urlManagerCache = (containerName) => {
  const { tpp } = getTPPServices(containerName);
  const cacheService = tpp.getService(URL_CACHE);
  if (!cacheService) {
    const cache = new Map();
    tpp.register(URL_CACHE, cache);
    return cache;
  }
  return cacheService;
};

const memoUrlParsed = (url, value, isBranded, customUom) => {
  const parsedCache = urlManagerCache();
  if (!validKey(url)) {
    return null;
  }
  let key = `parse-${url}`;
  if (isBranded) {
    key = `branded-${key}`;
  }
  if (customUom) {
    key = `${key}-${customUom}`;
  }
  if (value) {
    parsedCache.set(key, value);
    return value;
  }

  return parsedCache.get(key);
};

const memoPathDetected = (path, value, prefix) => {
  const parsedCache = urlManagerCache();
  let key = `path-detected-${path}`;
  if (prefix) {
    key = `${prefix}-${key}`;
  }
  if (value) {
    parsedCache.set(key, value);
    return value;
  }
  return parsedCache.get(key);
};

// Utility functions to store boatConstanParsers and boatConstantsReplacers
/**
 * We need a map within a map to be able to store functions with objects as keys
 * @param mapKey hardcoded string to identify the functions to store
 * @param constantsKey boatConstants object we will use as a key
 * @param mapVal the functions to store
 * @param containerName to deal with DI, default is empty and works.
 * @returns {* @returns {any} the function stored in the cache}
 */
const parserFunctionsCache = (mapKey, constantsKey, mapVal, containerName = '') => {
  const parsedCache = urlManagerCache(containerName);
  if (!parsedCache.has(mapKey)) {
    parsedCache.set(mapKey, new Map());
  }
  if (constantsKey && mapVal) {
    parsedCache.get(mapKey).set(constantsKey, mapVal);
    return mapVal;
  }
  return parsedCache.get(mapKey).get(constantsKey);
};

const urlParserCache = (constantsKey, mapVal = null, containerName = '') => {
  return parserFunctionsCache(URL_PARSER_CACHE, constantsKey, mapVal, containerName);
};

const urlReplacerCache = (constantsKey, mapVal = null, containerName = '') => {
  return parserFunctionsCache(URL_REPLACER_CACHE, constantsKey, mapVal, containerName);
};

export { urlManagerCache, memoUrlParsed, parserFunctionsCache, memoPathDetected, urlParserCache, urlReplacerCache, URL_CACHE };
